module.exports = __webpack_public_path__ + "static/img/product_patrol.175581a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_patrol.jpg
// module id = Fmml
// module chunks = 0